import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import utils from '../../helpers/utils';
import ImageTooltipContent from './ImageTooltipContent';
import PropTypes from 'prop-types';

const TooltipImage = (props) => {
  const isPrivatePath = props.filePath.startsWith('/upload/static/private/');

  const handleClick = () => {
    if ( !isPrivatePath) {
      utils.openFile(props.filePath);
    }
  };

  const commonProps = {
    className: 'cursor-pointer d-inline-block ' + (props.className || ''),
    onClick: handleClick,
  };

  return (
    <>
      {!props.filePath.endsWith('.pdf') ? (
        <Tippy
          animation="scale"
          duration={[300, 250]}
          content={
            <ImageTooltipContent
              filePath={utils.defaultUrl() + props.filePath}
              fileName={props.fileName}
            />
          }
          interactive={true}
          placement="bottom"
        >
          <div {...commonProps}>{props.children}</div>
        </Tippy>
      ) : (
        <div {...commonProps}>{props.children}</div>
      )}
    </>
  );
};

TooltipImage.propTypes = {
  filePath: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default TooltipImage;
